export default __webpack_public_path__ + "aspnet.c116f8ac.png";